import ROUTERS from "./router";


const navLinks = [
  {
    id: 1,
    name: 'home',
    icon: '',
    action: '',
    toUrl: ROUTERS.HOME,
  },
  {
    id: 2,
    name: 'login',
    icon: '',
    action: 'login',
    toUrl: ROUTERS.LOGIN,
  },
  {
    id: 3,
    name: 'Image',
    icon: '',
    action: '',
    toUrl: ROUTERS.PHOTO,
  },
  {
    id: 4,
    name: 'Video',
    icon: '',
    action: '',
    toUrl: ROUTERS.VIDEO,
  },
];

export default navLinks;